module.exports = __webpack_public_path__ + "assets/retina_CircleInRhombusDetailed.d68164f1d0197d80eec15e5e0079b457.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleInRhombusDetailed.png
// module id = 641
// module chunks = 0